import { createAsyncThunk, createSlice } from "@reduxjs/toolkit";
import apiAxios from "helpers/apiAxios";
import { toast } from "react-toastify";

import {
  initialState,
  handleFulfilled,
  setNestedPageHelper,
  setNestedPageSizeHelper,
  setNestedParamsHelper,
  resetNestedParamsHelper,
  setSortParamsHelper,
  setFilterTagHelper,
  resetFilterTagHelper,
  handlePayload
} from "helpers/reducerHelpers";

const requestTerminalAccountUrl = "/request/terminal_accounts";

export const getRequestTerminalAccounts = createAsyncThunk(
  "TerminalAccount/getRequestTerminalAccounts",
  async (params) => {
    try {
      const response = await apiAxios.get(requestTerminalAccountUrl, { params } )
      return response.data
    }
    catch(error) {
      throw new Error(error.message)
    }
  }
)

export const getRequestTerminalAccount = createAsyncThunk(
  "TerminalAccount/getRequestTerminalAccount",
  async (recordId) => {
    try {
      const response = await apiAxios.get(`${requestTerminalAccountUrl}/${recordId}`)
      return response.data
    }
    catch(error) {
      throw new Error(error.message)
    }
  }
)

export const createRequestTerminalAccount = createAsyncThunk(
  "TerminalAccount/createRequestTerminalAccount",
  async (data, { rejectWithValue }) => {
    try {
      const response = await apiAxios.post(requestTerminalAccountUrl, data)
      return response.data
    }
    catch(error){
      return rejectWithValue(error.response.data)
    }
  }
)

export const updateRequestTerminalAccount = createAsyncThunk(
  "UserAccount/updateRequestTerminalAccount",
  async ({recordId, data}, { rejectWithValue }) => {
    try {
      const response = await apiAxios.put(`${requestTerminalAccountUrl}/${recordId}`, data)
      return response.data
    }
    catch(error){
      return rejectWithValue(error.response.data)
    }
  }
)

export const deleteRequestTerminalAccount = createAsyncThunk(
  "UserAccount/deleteRequestTerminalAccount",
  async (recordId, { rejectWithValue }) => {
    try {
      const response = await apiAxios.delete(`${requestTerminalAccountUrl}/${recordId}`)
      return response.data
    }
    catch(error){
      return rejectWithValue(error.response.data)
    }
  }
)

export const closeRequestTerminalAccount = createAsyncThunk(
  "TerminalAccount/closeRequestTerminalAccount",
  async ({recordId, data}, { rejectWithValue }) => {
    try {
      const response = await apiAxios.post(`${requestTerminalAccountUrl}/${recordId}/close`, data)
      return response.data
    }
    catch(error){
      return rejectWithValue(error.response.data)
    }
  }
)

export const exportData = createAsyncThunk(
  "UserAccount/exportData",
  async (params) => {
    //remove page and per_page in object
    const { page, per_page, ...rest } = params
    console.log(rest, page, per_page)

    const response = await apiAxios.get(`${requestTerminalAccountUrl}/export`, {params, responseType: 'blob'})

    const url = window.URL.createObjectURL(new Blob([response.data]));
    const link = document.createElement('a');
    link.href = url;
    link.setAttribute('download', `request-terminal-account.xlsx`);
    document.body.appendChild(link);
    link.click();
  }
)

const isRejectedAction = (action) => (action.type.startsWith("TerminalAccount/") || action.type.startsWith("UserAccount/")) && action.type.endsWith("/rejected");

const terminalAccountSlice = createSlice({
  name: "request_terminal_account",
  initialState: {
    ...initialState
  },
  reducers: {
    setNestedPage: setNestedPageHelper,
    setNestedPageSize: setNestedPageSizeHelper,
    setNestedParams: setNestedParamsHelper,
    resetNestedParams: resetNestedParamsHelper,
    setSortParams: setSortParamsHelper,
    setFilterTag: setFilterTagHelper,
    resetFilterTag: resetFilterTagHelper
  },
  extraReducers: (builder) => {
    builder
      .addCase(getRequestTerminalAccounts.fulfilled, (state, action) => {
        handleFulfilled(state, action, "allData");
        // Store statistics separately
        if (action.payload?.statistics) {
          state.allData.statistics = action.payload.statistics;
        }
      })
      .addCase(getRequestTerminalAccount.fulfilled, (state, action) => {
        handlePayload(state, action)
      })
      .addCase(createRequestTerminalAccount.fulfilled, (state, action) => {
        handlePayload(state, action, "create")
      })
      .addCase(updateRequestTerminalAccount.fulfilled, (state, action) => {
        handlePayload(state, action)
      })
      .addCase(deleteRequestTerminalAccount.fulfilled, (state, action) => {
        handlePayload(state, action, "delete")
      })
      .addCase(closeRequestTerminalAccount.fulfilled, (state, action) => {
        handlePayload(state, action)
      })
      .addCase(exportData.pending, (state) => {
        state.exporting = true
      })
      .addCase(exportData.fulfilled, (state) => {
        state.exporting = false
        toast.success("Data has been exported successfully.")
      })
      .addMatcher(
        isRejectedAction,
        (state, action) => {
          state.loading = false;
          toast.error(action.payload?.message || action.payload?.error || action?.error?.message)
        }
      );
  }
})

export const {
  setNestedPage,
  setNestedPageSize,
  setNestedParams,
  resetNestedParams,
  setSortParams,
  setFilterTag,
  resetFilterTag
} = terminalAccountSlice.actions;

export default terminalAccountSlice.reducer;